const BookingActions = {
    UPDATE: 'UPDATE_BOOKINGS',
}

export default BookingActions;